/* 呂蒙（字子明） */
import { gd } from '../../core/kit.ts';
import { defineHero, hook } from '../define.ts';

export default defineHero({
  id: 'lvmeng', name: '呂蒙', sub: '字子明', faction: 'wu', role: '刺客', weapon: 'sword',
  look: { fx: '#e8ecf0', c: { plume: '#f0f2f5' } },
  skills: [
    ['白衣渡江', 'stealth', '披上白衣隱身 {3.5/4/4.5/5} 秒，現身後的第一擊傷害 +50%。', { sig: 'whiteRobe', el: 'ice' }],
    ['突襲', 'multi', '三段連擊，每段 {50/80/110/140} 傷害。'],
    ['士別三日', 'passive', '每升一級，技能傷害 +{0.35/0.5/0.65/0.8}%（25 級時 +{8.75/12.5/16.25/20}%）。', { pv: {}, sig: 'growsp', per: [0.35, 0.5, 0.65, 0.8] }],
    ['奪取荊州', 'slam', '躍擊落點造成 {300/450/600} 傷害並擊飛 0.8 秒；在敵方城寨附近傷害加倍。', { sig: 'siege' }],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 士別三日：每級技能傷害 +%
    hook('recalc', 20, function (u, sg) { if (sg && sg.growsp) u.sp = (u.sp || 0) + u.lv * sg.growsp.v('per'); }),
  ],
  aiSig: {
    // 白衣渡江：隱身接近再出手
    whiteRobe: ({ w, u, t }) => { const d = t ? gd(u.x, u.y, t.x, t.y) : 1e9; return !!t && t.kind === 'hero' && d > 250 && d < 750 && u.hp > u.maxHp * 0.4; },
  },
});
